// extracted by mini-css-extract-plugin
export var button = "mediaForContact-module--button--ab879";
export var contentContainer = "mediaForContact-module--contentContainer--9277c";
export var leftContainer = "mediaForContact-module--leftContainer--4500e";
export var mediaForContactContainer = "mediaForContact-module--mediaForContactContainer--5cbe7";
export var mediaForContactContentSection = "mediaForContact-module--mediaForContactContentSection--7838b";
export var rightContainer = "mediaForContact-module--rightContainer--911bf";
export var subheadline = "mediaForContact-module--subheadline--0a45a";